import React from 'react'
import Lottie from 'react-lottie'

import contentTwo from '../srcAnimationJson/content2.json'

import './HomeContentTwo.module.scss'

class HomeContentTwo extends React.Component {
  static defaultProps = {
    height: 270,
    width: 270
  }

  render () {
    const { width, height } = this.props
    const headerEffect = {
      loop: true,
      autoplay: true,
      animationData: contentTwo,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    }

    return (
      <div className='atom-animation' style={{ height }}>
        <Lottie
          options={headerEffect}
          height={height}
          width={width}
        />
      </div>
    )
  }
}

export default HomeContentTwo

